import { ListDataParams, ListDataResponse } from '@api-client/types';
import { NoteInterface } from '@interfaces/Quotes.interface';
import BaseApiClient from '../BaseApiClient';

export class ApiNote extends BaseApiClient {
  // --------------------------------------
  // * Notes api's *

  // - Get all Notes - live

  async list(
    listData: ListDataParams,
    searchTerm?: string
  ): Promise<ListDataResponse<NoteInterface>> {
    return new Promise((resolve, reject) => {
      if (searchTerm) {
        if (!listData.filters) listData.filters = {};
        listData.filters.note_title = searchTerm;
      }
      this.client
        .getList('/note', listData)
        .then((res) => {
          if (res.data) {
            resolve({
              items: res.data.data,
              pagination: {
                page: res.data.meta?.current_page,
                perPage: res.data.meta?.per_page,
                total: res.data.meta?.total
              }
            });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Store an item
   */
  async storeNote(dto: {
    entity_uuid: string;
    note_title: string;
    note_text: string;
  }): Promise<NoteInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .post('/note', dto)
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Create or update a note depending on presence of `id`.
   */
  async saveNote(dto: {
    entity_uuid: string;
    note_title: string;
    note_text: string;
    id?: number;
  }): Promise<NoteInterface> {
    if (dto.id != null) {
      return this.updateNote(dto.id, {
        entity_uuid: dto.entity_uuid,
        note_title: dto.note_title,
        note_text: dto.note_text
      });
    }
    return this.storeNote({
      entity_uuid: dto.entity_uuid,
      note_title: dto.note_title,
      note_text: dto.note_text
    });
  }

  /**
   * Update a note
   */
  async updateNote(
    id: number,
    dto: {
      entity_uuid: string;
      note_title: string;
      note_text: string;
    }
  ): Promise<NoteInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .put(`/note/${id}`, dto)
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Store an item mock
   */

  // ---------------------------------------------
  async deleteNote(id: number) {
    return this.client.delete(`/note/${id}`);
  }
}

export { noteQueryKeys } from './query-keys';
export type { NoteListQueryParams } from './query-keys';
export { useNoteListQuery } from './use-note-queries';
export {
  useNoteStoreMutation,
  useNoteSaveMutation,
  useNoteUpdateMutation,
  useNoteDeleteMutation
} from './use-note-mutations';
export type {
  NoteStoreVariables,
  NoteSaveVariables,
  NoteUpdateVariables
} from './use-note-mutations';
